import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Output,
  PLATFORM_ID,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { CartService } from '../../shared/services/cart.service';
import { AuthService } from '../../shared/services/auth.service';
import { BuyNowButtonComponent } from '../buy-now-button/buy-now-button.component';
import { BuyNowPopupComponent } from '../buy-now-popup/buy-now-popup.component';
import { LoaderService } from '../../shared/services/loader.service';
import { ScrapCertificateService } from '../../shared/services/scrap-certificate.service';
import { ScrapCertificateModalComponent } from '../../shared/components/scrap-certificate-modal/scrap-certificate-modal.component';
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';

@Component({
  selector: 'app-partsforyou',
  standalone: true,
  imports: [
    CommonModule,
    BuyNowButtonComponent,
    BuyNowPopupComponent,
    ScrapCertificateModalComponent,
  ],
  templateUrl: './partsforyou.component.html',
  styleUrl: './partsforyou.component.scss',
})
export class PartsforyouComponent implements OnInit, OnDestroy {
  @Output() buyNowClicked = new EventEmitter<string>();
  @Output() addToCartClicked = new EventEmitter<string>();
  @Input() chasisNumber: any;
  @Input() partType: any;

  currentSlide = 0;
  visibleSlides = 1;
  slideWidth = 310;
  gap = 2;
  isBrowser: boolean;

  products: any[] = [];
  isPartsforyou: boolean = false;
  isMobile: boolean = false;
  isLoggedIn: boolean = false;
  userData: any;
  isScrapPart: boolean = false;
  showScrapCertificateModal = false;
  private dataLoaded = false;

  private sub: Subscription = new Subscription();

  isBuyNowPopupOpen = false;
  selectedProductForBuyNow: any = null;
  pendingBuyNowProduct: any = null;
  hoveredProduct: any = null;
  itemsAddedToCart: Set<string> = new Set(); // Track cart state per product by inventory_id
  imageScrollInterval: any = null; // Store interval timer for auto-scrolling images
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private cartService: CartService,
    private authService: AuthService,
    private loaderService: LoaderService,
    private scrapCertificateService: ScrapCertificateService,
    private behaviourSubject: BehaviourSubjectService,
    private cdr: ChangeDetectorRef,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  // Removed duplicate declaration of isMobile

  // Removed duplicate onResize method
  ngOnInit(): void {
    if (this.dataLoaded) return;
    this.dataLoaded = true;

    this.partType = this.partType ? true : false;
    console.log('partype', this.partType);
    this.sub.add(
      this.route.params.subscribe((params) => {
        this.isPartsforyou = params['id'] ? true : false;
      }),
    );

    if (this.isBrowser) {
      this.updateVisibleSlides();

      // Subscribe to authentication state changes
      this.sub.add(
        this.authService.isLoggedIn$.subscribe((isLoggedIn) => {
          this.isLoggedIn = isLoggedIn;
          if (isLoggedIn && this.pendingBuyNowProduct) {
            setTimeout(() => {
              this.selectedProductForBuyNow = this.pendingBuyNowProduct;
              this.isBuyNowPopupOpen = true;
              this.pendingBuyNowProduct = null;
              this.cdr.detectChanges();
            }, 500);
          }
        }),
      );

      // Subscribe to user data changes
      this.sub.add(
        this.authService.userData$.subscribe((userData) => {
          this.userData = userData;
          // this.checkAndLoadData();
        }),
      );

      // Initial check for existing auth state
      // if(this.userData && this.isLoggedIn) {
      this.checkAndLoadData();
      // }
    }

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    // Sync scrap certificate modal state with shared service
    this.sub.add(
      this.scrapCertificateService.showScrapCertificateModal$.subscribe(
        (show) => {
          this.showScrapCertificateModal = show;
          this.cdr.detectChanges();
        },
      ),
    );
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.isBrowser) {
      this.updateVisibleSlides();
    }
  }

  updateVisibleSlides(): void {
    if (!this.isBrowser) return;

    const windowWidth = window.innerWidth;
    if (windowWidth < 640) {
      this.visibleSlides = 2;
      this.slideWidth = Math.round(windowWidth * 0.55) + 8;
      this.gap = 8;
      this.isMobile = true;
    } else if (windowWidth < 768) {
      this.visibleSlides = 2;
      this.slideWidth = 240 + 12;
      this.gap = 12;
      this.isMobile = true;
    } else if (windowWidth < 1024) {
      this.visibleSlides = 4;
      this.slideWidth = 220 + 16;
      this.gap = 16;
      this.isMobile = false;
    } else if (windowWidth < 1280) {
      this.visibleSlides = 4;
      this.slideWidth = 260 + 16;
      this.gap = 16;
      this.isMobile = false;
    } else {
      this.visibleSlides = 4;
      this.slideWidth = 300 + 16;
      this.gap = 16;
      this.isMobile = false;
    }
  }

  checkAndLoadData(): void {
    // For parts for you, we can load data regardless of login status
    // but we might want to show different content for logged-in users
    setTimeout(() => {
      this.getProductList();
    }, 200);
  }

  next(): void {
    const maxSlide = this.products.length - this.visibleSlides;
    if (this.currentSlide < maxSlide) {
      this.currentSlide++;
    } else {
      this.currentSlide = maxSlide; // clamp at last valid slide
    }
  }

  prev(): void {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  }

  onBuyNowClicked(productId: any): void {
    this.onBuyNow(productId);
  }

  onAddToCartClicked(event: Event, productId: any): void {
    event.stopPropagation(); // Prevent event bubbling to parent elements
    // Mark as touched so validation messages can show after click
    if (productId) {
      productId.quantityTouched = true;
      this.cdr.markForCheck();
    }

    // Validate selected quantity for all products against fix_quantity
    if (!this.isQuantityAvailable(productId)) {
      return;
    }

    // Stock availability check
    if (!this.checkStockAvailability(productId)) {
      return;
    }

    // Use the shared service to handle scrap part detection
    this.cartService.handleAddToCart(
      productId, // Pass the product data
      'Store Pickup',
      this.getQuantityForPopup(productId),
      productId.selectedUnit === 'kg'
        ? 'Kg'
        : productId.selectedUnit === 'liter'
          ? 'Liter'
          : 'Ton',
      () => {
        // Callback for non-scrap parts
        this.addToCartForNonScrapParts(productId);
      },
      () => {
        // Callback for login required
        this.openLoginPopup();
      },
    );
  }

  private addToCartForNonScrapParts(productId: any): void {
    if (!this.isLoggedIn) {
      // Find the product data from the products array
      const productData = this.products.find(
        (product: any) => product.inventory_id === productId?.inventory_id,
      );
      if (productData) {
        // Get quantity and unit for scrap parts
        const quantity = this.getQuantityForPopup(productData);
        const unit =
          productData.selectedUnit === 'kg'
            ? 'Kg'
            : productData.selectedUnit === 'liter'
              ? 'Liter'
              : 'Ton';

        // Add to local storage for non-logged in users with complete product data
        this.cartService.addToLocalStorage(
          productData,
          'Store Pickup',
          quantity,
          unit,
        );
        this.itemsAddedToCart.add(productId?.inventory_id);
        this.addToCartClicked.emit(productId?.inventory_id);
        this.cdr.detectChanges(); // Trigger change detection to show "Go to Cart" button immediately
        console.log(
          'Item added to local storage cart:',
          productId?.inventory_id,
        );
      }
      return;
    }
    localStorage.removeItem('addtocartpart_type');
    localStorage.setItem('addtocartpart_type', productId?.part_type);

    // Get quantity and unit for scrap parts
    const quantity = this.getQuantityForPopup(productId);
    const unit =
      productId.selectedUnit === 'kg'
        ? 'Kg'
        : productId.selectedUnit === 'liter'
          ? 'Liter'
          : 'Ton';

    this.sub.add(
      this.cartService
        .addToCart(productId?.inventory_id, 'Store Pickup', quantity, unit)
        .subscribe({
          next: () => {
            this.itemsAddedToCart.add(productId?.inventory_id); // Set success state for specific product
            this.addToCartClicked.emit(productId);
            this.cdr.detectChanges(); // Trigger change detection to show "Go to Cart" button immediately
            // Product added successfully - user can manually navigate to cart using "Go to Cart" button
          },
          error: (err) => {
            console.error('Error adding to cart:', err);
          },
          complete: () => {
            // No loader needed
          },
        }),
    );
  }

  /**
   * Validates stock availability before adding to cart
   * Checks available quantity (stock - reserved) against requested quantity
   */
  private checkStockAvailability(product: any): boolean {
    if (!product) return false;

    // Get stock and reserved quantities from API response
    const stockQuantity =
      Number(product.stock_quantity_s || product.STOCK_QUANTITY_s) || 0;
    const reservedQuantity =
      Number(product.reserved_quantity || product.RESERVED_QUANTITY_s) || 0;
    const availableQuantity =
      product.available_quantity !== undefined
        ? Number(product.available_quantity)
        : stockQuantity - reservedQuantity;

    // Get requested quantity
    const requestedQuantity = this.getQuantityForPopup(product) || 1;

    // Check if available stock exists and if requested quantity exceeds it
    if (availableQuantity > 0 && requestedQuantity > availableQuantity) {
      const unit = product.selectedUnit || 'units';
      const errorMsg = `Quantity exceeds available stock. Available quantity is ${availableQuantity} ${unit}.`;
      console.error(errorMsg);
      return false;
    }

    // Check if no stock available
    if (availableQuantity <= 0) {
      console.error('This product is currently out of stock.');
      return false;
    }

    return true;
  }

  goToCart(event: Event) {
    event.stopPropagation(); // Prevent event bubbling to parent elements
    this.cartService.navigateToCart();
  }

  openLoginPopup() {
    // Use the shared login modal service
    this.behaviourSubject.openLoginModal('other');
  }

  /**
   * Checks if a specific product has been added to cart
   */
  isProductAddedToCart(product: any): boolean {
    return this.itemsAddedToCart.has(product?.inventory_id);
  }

  getProductList() {
    this.loaderService.show();
    try {
      let data = {
        limit: 12,
        offset: 0,
        chassis_number: this.isPartsforyou
          ? this.chasisNumber
            ? this.chasisNumber
            : ''
          : '',
        is_used_see_more: this.isPartsforyou ? false : true,
        get_your_vehicles: this.isPartsforyou ? false : true,
        action_type: 'exclude_part',
        part_type: this.partType ? 'Scrap Part' : 'Used Part',
        seller_code: ''
        // "get_plp_data": true
      };

      this.sub.add(
        this.apiService.getProductlistData(data).subscribe({
          next: (value) => {
            if (value.success) {
              this.products = value.data.part_list;
              console.log([this.products]);
              this.products.forEach((product) => {
                if (Array.isArray(product.part_image_path)) {
                  product.images = product.part_image_path;
                } else if (product.part_image_path) {
                  product.images = [product.part_image_path];
                } else {
                  product.images = [];
                }
                product.currentImageIndex = 0;
                // Initialize quantity and unit properties
                // Check if product is oil category with default_uom as 'litr' or 'liter'
                if (this.isOilProductWithLiter(product)) {
                  product.selectedUnit = 'liter'; // Set to liter for oil products
                } else {
                  product.selectedUnit = 'ton'; // Default unit is ton
                }
                // For scrap parts, require explicit selection (no default)
                if (product.part_type === 'Scrap Part') {
                  product.quantity = null;
                  product.customKgQuantity = null;
                  product.customTonQuantity = null;
                  if (this.isOilProductWithLiter(product)) {
                    product.customLiterQuantity = null; // For custom liter input
                  }
                } else {
                  product.quantity = 1; // Default for non-scrap
                  product.customKgQuantity = null;
                }
                product.quantityTouched = false; // Track user interaction with quantity
              });

              console.log('Loaded banner data:', this.products);
              // Initializ  e carousel after data is loaded
              this.loaderService.hide();
            } else {
              this.products = [];
              this.loaderService.hide();
            }
          },
          error: (err) => {
            console.error('Error loading products:', err);
            this.loaderService.hide();
          },
          complete: () => {
            this.loaderService.hide();
          },
        }),
      );
    } catch (error) {
      console.error('Error in products:', error);
      this.loaderService.show();
      throw error;
    }
  }

  gotoProductDetails(id: any) {
    localStorage.removeItem('product_categoryType');
    localStorage.setItem('product_categoryType', JSON.stringify(id?.part_type));
    console.log('product id', id);
    // this.router.navigate(['/product-detail', id]);
    this.router.navigate(['/product-detail/' + id?.part_number], {
      queryParams: { preserveScroll: 'true' },
    });
  }

  ngOnDestroy() {
    // Clear image scroll interval to prevent memory leaks
    if (this.imageScrollInterval) {
      clearInterval(this.imageScrollInterval);
      this.imageScrollInterval = null;
    }

    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  onBuyNow(product: any) {
    // For scrap parts, require explicit valid quantity selection before proceeding
    if (product?.part_type === 'Scrap Part') {
      product.quantityTouched = true;
      this.cdr.markForCheck();
      if (this.shouldDisableButtons(product)) {
        return;
      }
    }

    // Check if user is logged in first
    if (!this.isLoggedIn && !this.authService.isLoggedIn) {
      this.pendingBuyNowProduct = product;
      this.openLoginPopup();
      return;
    }

    if (this.shouldDisableButtons(product)) {
      product.quantityTouched = true;
      this.cdr.markForCheck();
      return;
    }

    // Check if this is a scrap part
    if (this.scrapCertificateService.isScrapPart(product)) {
      // For scrap parts, check certificate match before proceeding to buy now
      this.scrapCertificateService.handleAddToCart(
        product,
        () => {
          // Callback for when certificate matches - proceed with buy now
          this.selectedProductForBuyNow = product;
          this.isBuyNowPopupOpen = true;
          this.cdr.detectChanges();
        },
        () => {
          // Callback for login required
          this.pendingBuyNowProduct = product;
          this.openLoginPopup();
        },
      );
      return;
    }

    this.selectedProductForBuyNow = product;
    this.isBuyNowPopupOpen = true;
    this.cdr.detectChanges();
  }

  onPaymentSuccess(event: any) {
    this.closeBuyNowPopup();
    // Navigate to order confirmation page with order details
    if (event && event.data) {
      this.router.navigate(['/order-confirmation'], {
        state: { orderDetail: event.data },
      });
    } else {
      // Fallback navigation if no order details
      this.router.navigate(['/order-confirmation']);
    }
  }

  closeBuyNowPopup() {
    this.isBuyNowPopupOpen = false;
    this.selectedProductForBuyNow = null;
  }

  /**
   * Handles unit change (ton/kg/liter) for a product
   */
  onUnitChange(product: any, event: any) {
    const selectedUnit = event.target.value;
    product.selectedUnit = selectedUnit;
    product.quantityTouched = true;

    if (selectedUnit === 'kg') {
      // When switching to kg, reset custom quantity if not set
      if (!product.customKgQuantity) {
        product.customKgQuantity = '';
      }
      // Clear ton and liter-related properties
      product.quantity = '';
      product.customTonQuantity = '';
      product.customLiterQuantity = '';
    } else if (selectedUnit === 'liter') {
      // When switching to liter, reset custom quantity if not set
      if (!product.customLiterQuantity) {
        product.customLiterQuantity = '';
      }
      // Clear ton and kg-related properties
      product.quantity = '';
      product.customTonQuantity = '';
      product.customKgQuantity = '';
    } else {
      // When switching to ton, reset to default quantity
      product.quantity = '';
      product.customTonQuantity = '';
      product.customKgQuantity = '';
      product.customLiterQuantity = '';
    }
  }

  /**
   * Handles select dropdown changes for ton quantity
   */
  onTonQuantitySelect(product: any, event: any) {
    const value = event.target.value;

    if (value === 'custom') {
      product.quantity = 'custom';
      product.customTonQuantity = '';
      // Focus the input field after Angular updates
      setTimeout(() => {
        const customInput = document.querySelector(
          `#customInput-${product.part_number}`,
        ) as HTMLInputElement;
        if (customInput) {
          customInput.focus();
        }
      }, 0);
    } else if (value) {
      product.quantity = parseFloat(value);
      product.customTonQuantity = '';
    } else {
      product.quantity = '';
      product.customTonQuantity = '';
    }
  }

  /**
   * Handles input changes for custom ton quantity
   */
  onCustomTonQuantityInput(product: any, event: any) {
    const value = event.target.value;
    product.customTonQuantity = value;
  }

  /**
   * Handles blur event for custom ton quantity input
   */
  onCustomTonQuantityBlur(product: any, event: any) {
    const value = event.target.value;
    if (!value || parseFloat(value) <= 0) {
      // If invalid or empty, reset to select mode
      product.quantity = '';
      product.customTonQuantity = '';
    } else {
      product.customTonQuantity = parseFloat(value);
    }
  }

  /**
   * Handles quantity change for ton units (legacy method for compatibility)
   */
  onQuantityChange(product: any, event: any) {
    const selectedQuantity = event.target.value;
    product.quantity = parseInt(selectedQuantity);
  }

  /**
   * Handles custom kg quantity input
   */
  onKgQuantityChange(product: any, event: any) {
    const value = event.target.value;
    product.customKgQuantity = value;
    product.quantityTouched = true;
  }

  /**
   * Handles quantity change for liter units
   */
  onLiterQuantityChange(product: any, event: any) {
    const value = event.target.value;
    // Allow only numbers and decimal points
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      product.customLiterQuantity = value;
    }
    product.quantityTouched = true;
  }

  /**
   * Gets the current quantity display for a product
   */
  getCurrentQuantity(product: any): string {
    if (product.selectedUnit === 'kg') {
      return product.customKgQuantity || '';
    } else if (product.selectedUnit === 'liter') {
      return product.customLiterQuantity || '';
    }
    return product.quantity?.toString() || '1';
  }

  /**
   * Gets the quantity value for the buy now popup
   * Handles both kg and ton units properly
   */
  getQuantityForPopup(product: any): number {
    if (!product) return 1;

    if (product.selectedUnit === 'kg') {
      // For kg units, return custom kg quantity or default to 1
      if (!product.customKgQuantity || product.customKgQuantity === '') {
        return 1;
      }
      const kg = parseFloat(product.customKgQuantity);
      return isNaN(kg) || kg <= 0 ? 1 : kg;
    } else if (product.selectedUnit === 'liter') {
      // For liter units, return custom liter quantity or default to 1
      if (!product.customLiterQuantity || product.customLiterQuantity === '') {
        return 1;
      }
      const liter = parseFloat(product.customLiterQuantity);
      return isNaN(liter) || liter <= 0 ? 1 : liter;
    } else {
      // For ton units, return custom when selected, else predefined quantity
      if (product.quantity === 'custom') {
        if (!product.customTonQuantity || product.customTonQuantity === '') {
          return 1;
        }
        const customTon = parseFloat(product.customTonQuantity);
        return isNaN(customTon) || customTon <= 0 ? 1 : customTon;
      }
      const qty =
        typeof product.quantity === 'number'
          ? product.quantity
          : parseFloat(product.quantity);
      return isNaN(qty) || qty <= 0 ? 1 : qty;
    }
  }

  viewall(section: any) {
    localStorage.removeItem('filterState');
    localStorage.removeItem('category');
    localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('seemore');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('guideSearchData');
    localStorage.setItem('seemore', section);

    this.router.navigate(['/product-list']);
  }

  /**
   * Gets the selected quantity for a product based on the current unit
   * Returns quantity in kg for consistent comparison
   */
  getSelectedQuantity(product: any): number {
    if (!product) return 0;
    if (product.part_type === 'Scrap Part') {
      if (product.selectedUnit === 'kg') {
        // For kg units, return custom kg quantity or 0 if not set
        if (!product.customKgQuantity || product.customKgQuantity === '') {
          return 0;
        }
        const qty = parseFloat(product.customKgQuantity);
        return isNaN(qty) ? 0 : qty;
      } else if (product.selectedUnit === 'liter') {
        // For liter units, return custom liter quantity or 0 if not set
        if (
          !product.customLiterQuantity ||
          product.customLiterQuantity === ''
        ) {
          return 0;
        }
        const qty = parseFloat(product.customLiterQuantity);
        return isNaN(qty) ? 0 : qty;
      } else {
        // For ton units, convert to kg (1 ton = 1000 kg)
        let tonQuantity = 0;
        if (product.quantity === 'custom') {
          if (!product.customTonQuantity || product.customTonQuantity === '') {
            tonQuantity = 0;
          } else {
            const qty = parseFloat(product.customTonQuantity);
            tonQuantity = isNaN(qty) ? 0 : qty;
          }
        } else if (
          product.quantity === '' ||
          product.quantity === null ||
          product.quantity === undefined
        ) {
          tonQuantity = 0;
        } else {
          tonQuantity = product.quantity || 0;
        }
        return tonQuantity * 1000;
      }
    } else {
      // For Used Parts, return quantity or default to 1
      return product.quantity || 1;
    }
  }

  /**
   * Gets the available quantity for a product in kg
   */
  getAvailableQuantity(product: any): number {
    if (!product) return 0;

    return (
      product.max_booking_qty ||
      product.max_booking_quantity ||
      product.max_quantity ||
      product.available_quantity ||
      product.fix_quantity ||
      0
    );
  }

  /**
   * Validates if the selected quantity is available
   * Compares quantities in kg for consistency
   */
  isQuantityAvailable(product: any): boolean {
    const selectedQuantityInKg = this.getSelectedQuantity(product);
    const availableQuantityInKg = this.getAvailableQuantity(product);
    // Use product.min_quantity or min_qty from API (default to 0 if not provided)
    const minQuantityInKg = product.min_quantity || product.min_qty || 0;

    // For used parts, if fix_quantity is 0 or not set, allow adding to cart
    // (similar to shouldDisableButtons logic)
    if (product.part_type !== 'Scrap Part') {
      // For used parts, if fix_quantity is 0 or not set, allow adding to cart
      // Only validate against fix_quantity if it's explicitly set and greater than 0
      if (availableQuantityInKg === 0 || !product.fix_quantity) {
        // Allow if minimum quantity requirement is met
        return (
          selectedQuantityInKg >= minQuantityInKg && selectedQuantityInKg > 0
        );
      }
    }

    return (
      selectedQuantityInKg >= minQuantityInKg &&
      selectedQuantityInKg <= availableQuantityInKg &&
      selectedQuantityInKg > 0
    );
  }

  /**
   * Checks if product is an oil/fluid product with liter (ltr) unit of measurement
   * Used to determine if product should display quantities in liters instead of kg
   */
  isOilProductWithLiter(product: any): boolean {
    if (!product) return false;

    // Check if default_uom is liter/litr/ltr (API returns "ltr")
    const isLiterUom =
      product.default_uom?.toLowerCase() === 'ltr' ||
      product.default_uom?.toLowerCase() === 'litr' ||
      product.default_uom?.toLowerCase() === 'liter' ||
      product.defaultUom?.toLowerCase() === 'ltr' ||
      product.defaultUom?.toLowerCase() === 'litr' ||
      product.defaultUom?.toLowerCase() === 'liter';

    if (!isLiterUom) return false;

    // Check if category contains oil or fluids (using includes for "OIL / Fluids" format)
    const scrapCategoryLower = product.scrap_category?.toLowerCase() || '';
    const categoryLower = product.category?.toLowerCase() || '';
    const materialLower = product.material?.toLowerCase() || '';
    const materialCompositionLower =
      product.material_composition?.toLowerCase() || '';
    const nameLower = product.name?.toLowerCase() || '';

    const isOilCategory =
      scrapCategoryLower.includes('oil') ||
      scrapCategoryLower.includes('fluids') ||
      categoryLower.includes('oil') ||
      categoryLower.includes('fluids') ||
      materialLower.includes('oil') ||
      materialLower.includes('fluids') ||
      materialCompositionLower.includes('oil') ||
      materialCompositionLower.includes('fluids') ||
      nameLower.includes('oil') ||
      nameLower.includes('fluids');

    const result = isOilCategory && isLiterUom;

    // Debug log for PartsForYou
    // console.log('🔍 PartsForYou isOilProductWithLiter called:', {
    //   name: product.table_name || product.name,
    //   default_uom: product.default_uom,
    //   material: product.material,
    //   scrap_category: product.scrap_category,
    //   isLiterUom: isLiterUom,
    //   isOilCategory: isOilCategory,
    //   result: result
    // });

    return result;
  }

  /**
   * Converts fix_quantity to tons
   * Assumes fix_quantity is in kg
   */
  getStockInTons(product: any): number {
    if (!product || !product.fix_quantity) return 0;

    // Convert kg to tons (1 ton = 1000 kg)
    return Math.floor(product.fix_quantity / 1000);
  }

  /**
   * Generates ton dropdown options based on available stock
   */
  getTonOptions(product: any): number[] {
    const stockInTons = this.getStockInTons(product);
    const options: number[] = [];

    // Generate options from 1 to available stock in tons
    // Maximum 10 options to keep dropdown manageable
    const maxOptions = Math.min(stockInTons, 10);

    for (let i = 1; i <= maxOptions; i++) {
      options.push(i);
    }

    return options;
  }

  /**
   * Checks if the product should be disabled due to quantity validation
   */
  shouldDisableButtons(product: any): boolean {
    if (!product) return true;
    if (product.part_type === 'Scrap Part') {
      const touched = !!product.quantityTouched;
      return !touched || !this.isQuantityAvailable(product);
    }
    // For Used Parts, validate against fix_quantity only if it's available
    const selectedQty = this.getSelectedQuantity(product);
    const availableQty = this.getAvailableQuantity(product);
    // If fix_quantity is not set or 0, don't disable (allow add to cart/buy now)
    if (availableQty === 0) {
      return false;
    }
    return selectedQty > availableQty;
  }

  getCurrentImage(product: any) {
    if (product?.part_image_path && product?.part_image_path.length > 0) {
      return product.part_image_path[product.currentImageIndex];
    }
    return 'assets/fonts/242x162.webp';
  }

  nextImage(product: any) {
    if (product.part_image_path && product.part_image_path.length > 0) {
      product.currentImageIndex =
        (product.currentImageIndex + 1) % product.part_image_path.length;
    }
  }

  prevImage(product: any) {
    if (product.part_image_path && product.part_image_path.length > 0) {
      product.currentImageIndex =
        (product.currentImageIndex - 1 + product.part_image_path.length) %
        product.part_image_path.length;
    }
  }

  /**
   * Start auto-scrolling images when user hovers over a product
   */
  onProductHover(product: any) {
    // Only work in browser environment
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.hoveredProduct = product;

    // Clear any existing interval first to prevent multiple intervals
    if (this.imageScrollInterval) {
      clearInterval(this.imageScrollInterval);
      this.imageScrollInterval = null;
    }

    // Only start auto-scroll if product has multiple images
    if (product?.part_image_path && product.part_image_path.length > 1) {
      // Ensure currentImageIndex is initialized
      if (typeof product.currentImageIndex !== 'number') {
        product.currentImageIndex = 0;
      }

      // Start auto-scrolling every 2 seconds
      this.imageScrollInterval = setInterval(() => {
        if (
          this.hoveredProduct === product &&
          product.part_image_path?.length > 1
        ) {
          // Calculate next index
          product.currentImageIndex =
            (product.currentImageIndex + 1) % product.part_image_path.length;
          // Manually trigger change detection to update the view
          this.cdr.detectChanges();
        } else {
          // Clear interval if conditions no longer met
          if (this.imageScrollInterval) {
            clearInterval(this.imageScrollInterval);
            this.imageScrollInterval = null;
          }
        }
      }, 2000);
    }
  }

  /**
   * Stop auto-scrolling images when user stops hovering
   */
  onProductHoverEnd() {
    this.hoveredProduct = null;

    // Clear the interval
    if (this.imageScrollInterval) {
      clearInterval(this.imageScrollInterval);
      this.imageScrollInterval = null;
    }
  }
}

interface Product {
  id: string;
  imageUrl: string;
  grade: string;
  gradeIconUrl: string;
  title: string;
  manufacturer: string;
  model: string;
  year: string;
  engineSpecs: string;
  currentPrice: string;
  originalPrice: string;
  discountPercentage: string;
  deliveryDate: string;
  storePickupReady: boolean;
  deliveryIconUrl: string;
  storePickupIconUrl: string;
  buyNowIconUrl: string;
  addToCartIconUrl: string;
}
